import DatabaseService from 'services/DatabaseService.js';
import {SET_USER_TOKEN,
        SET_USER_NO_COMPANY,
        SET_USER_PROFILE,
        SET_USER_RANK,
        SET_USER_HEALTH,
        SET_USER_BADGE_NUMBERS,
        SET_USER_ANNOUNCEMENTS_BADGE_DATE,
        SET_USER_CATEGORIES}  from 'actions/types'
import {setUserPlugins} from 'actions/userPlugins.js';
import {setFeatures} from 'actions/features.js';

//Action Creators
export const setUserToken = (token) => {
    return { type:SET_USER_TOKEN, token};
}
export const setUserNoCompany = (noCompany) => {
    return { type:SET_USER_NO_COMPANY, noCompany};
}
export const setUserProfile = (userProfile) => {
    return { type:SET_USER_PROFILE, userProfile};
}
export const setUserRank= (rank) => {
    return { type:SET_USER_RANK, rank};
}
export const setUserHealth = (health) => {
    return { type:SET_USER_HEALTH, health };
}
export const setUserBadgeNumbers = (badgeNumbers) => {
    return { type:SET_USER_BADGE_NUMBERS, badgeNumbers };
}
export const setUserAnnouncementsBadgeDate = (companyAnnouncementsBadgeDate) => {
    return { type:SET_USER_ANNOUNCEMENTS_BADGE_DATE, companyAnnouncementsBadgeDate };
}



//helpers
export const processUserProfile = (dispatch, userProfile) => {
    userProfile = {...userProfile, plugins:null};
    dispatch(setUserProfile(userProfile));
}



//Thunks
export const fetchMyProfile = (include) => (dispatch, getState) => {
    return new Promise(function(resolve, reject){
        DatabaseService.fetchMyProfile(include).then(function(result){
            if(!result.userProfile) {
                console.log("user - fetchMyProfile: error");
                reject("user - fetchMyProfile: error");
                return;
            }

            processUserProfile(dispatch, result.userProfile);
        
            dispatch(setUserRank(result.rank));
         
            if(result.categories)
                dispatch({type:SET_USER_CATEGORIES, userCategories:result.categories});
            if(result.plugins)
                dispatch(setUserPlugins(result.plugins, true));
            if(result.features)
                dispatch(setFeatures(result.features, true));
            if(result.health)
                dispatch(setUserHealth(result.health));
            
            resolve(result);
        },function(error){
            console.log("user - fetchMyProfile: error", error);
            reject(error)
        });

    });
}



export const fetchBadgeNumbers = () => (dispatch, getState) => {
    return new Promise(function(resolve, reject){
        DatabaseService.fetchBadgeNumbers().then(function(result){
            var badgeNumbers = {badge:result.badge, 
                                companyAnnouncementsBadge:result.companyAnnouncementsBadge};
            dispatch(setUserBadgeNumbers(badgeNumbers));
            resolve(result);
        },function(error){
            console.log("Users.fetchBadgeNumbers: error");
            reject(error)
        });

    });
}

export const updateCompanyAnnouncementsBadgeDate = (isoDateStr) => (dispatch, getState) => {
    return new Promise(function(resolve, reject){
        dispatch(setUserAnnouncementsBadgeDate(isoDateStr));
        DatabaseService.updateCompanyAnnouncementsBadgeDate(isoDateStr).then(function(result){
            var badgeNumbers = {badge:result.badge, 
                                companyAnnouncementsBadge:result.companyAnnouncementsBadge};
            dispatch(setUserBadgeNumbers(badgeNumbers));
            resolve(result);
        },function(error){
            console.log("Users.updateCompanyAnnouncementsBadgeDate: error");
            reject(error)
        });

    });
}



// WEBPACK FOOTER //
// ./src/actions/user.js